import { useSelector, useDispatch } from "react-redux";
import React, { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./App.css";
import Login from "./pages/auth/Login";
import RouteGuard from "./components/RouteGuard";
import Dashboard from "./pages/Dashboard";
import { selectRoles, logout, selectLoggedIn, selectIsImpersonating } from "./store/authSlice";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import Settings from "./pages/admin/Settings/Settings";
import useRoutesList from "./routes";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const roles = useSelector(selectRoles);
  const isLoggedIn = useSelector(selectLoggedIn);
  const isImpersonating = useSelector(selectIsImpersonating);
  const role = roles.length > 0 ? roles[0] : "";
  const routes = useRoutesList();

  useEffect(() => {
    // Allow super-user and impersonation mode
    if (isLoggedIn && role !== "super-user" && !isImpersonating) {
      dispatch(logout());
      navigate("/login");
    }
  }, [isLoggedIn, role, isImpersonating, dispatch, navigate]);

  const DashboardCont = () => {
    if (role === "turnkey_admin") {
      return <Settings />;
    } else {
      return <Dashboard />;
    }
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path="/login"
          element={
            <RouteGuard guest={true}>
              <Login />
            </RouteGuard>
          }
        />
        <Route
          path={"/forgot-password"}
          element={
            <RouteGuard guest={true}>
              <ForgotPassword />
            </RouteGuard>
          }
        />
        <Route
          path={"/password-reset/:token"}
          element={
            <RouteGuard guest={true}>
              <ResetPassword />
            </RouteGuard>
          }
        />
        <Route
          path="/dashboard"
          element={
            <RouteGuard auth={true}>
              <DashboardCont />
            </RouteGuard>
          }
        />

        {routes?.map((ro, i) => (
          <Route
            exact
            key={i}
            path={ro.path}
            element={
              ro.auth ? (
                <RouteGuard auth={ro.auth}>{ro.element}</RouteGuard>
              ) : (
                <>{ro.element}</>
              )
            }
          />
        ))}

        <Route
          path="*"
          element={
            <RouteGuard auth={true}>
              <Navigate to="/dashboard" />
            </RouteGuard>
          }
        />
      </Routes>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
          style: {
            background: "#fff",
            color: "#333",
          },
          success: {
            style: {
              background: "#f0fff4",
              border: "1px solid #C6F6D5",
            },
          },
          error: {
            style: {
              background: "#FFF5F5",
              border: "1px solid #FED7D7",
            },
          },
        }}
      />
    </>
  );
}

export default App;
